import * as React from 'react';
import { LinkedBondDetailLine } from './components';
import { useSanityNewsByUrlId } from '../../../../../../../../../../../../../../../../../../../../../../sanity';

export const LinkedBondsElementDetailsContent = () => {
  const {
    data: newsData,
  } = useSanityNewsByUrlId();
  const {
    showYield,
  } = newsData ?? {};
  const shortPresentationDimension = React.useMemo(() => [
    'C_CURRENCY.CODE',
    !showYield ? 'S_ACC.INT_RATE' : 'S_MARKET.YIELD',
    'S_ACC.OBL_END_DATE',
    'S_MARKET.QT_MIN',
    'GES_RAT_VAL_SP.SHORTCUT',
  ], [showYield]);
  return (
    <>
      {shortPresentationDimension.map((secondaryDimension, index, arr) => (
        <LinkedBondDetailLine
          secondaryDimension={secondaryDimension}
          withoutBorder={index === arr.length - 1}
        />
      ))}
    </>
  );
};
